import { ProductDoc } from '@gooduncles/gu-app-schema';
import { getProductDoc } from 'src/utils/firebase/firebase-short-cut';
import useSWRImmutable from 'swr/immutable';

/**
 * 상품 정보를 가져옵니다.
 * 10초 마다 갱신합니다.
 * @returns
 */
const useImmutableProductById = (id: ProductDoc['_id']) => {
  const {
    data,
    isLoading: productLoading,
    error: productError,
  } = useSWRImmutable(id ? id : null, getProductDoc, {
    revalidateOnMount: true,
    // 최초 요청후 10초간 중복 요청 방지
    dedupingInterval: 10 * 1000,
  });

  return {
    product: data,
    productLoading,
    productError,
  };
};

export default useImmutableProductById;
